import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { AlertContainer, Message, StatusColor } from "./alert.styles";

interface AlertProps {
  type?: "success" | "error" | "warning" | "info";
  message: string;
  onClose?: () => void;
}

const Alert = ({ type = "info", message, onClose }: AlertProps) => {
  return (
    <AlertContainer>
      <StatusColor className={`alert-${type}`} />
      <Message>{message}</Message>
      {onClose && (
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </AlertContainer>
  );
};

export default Alert;
